export function encodeObjectWith(object, separator) {
  return Object.keys(object)
    .map(function(key) {
      let temp =
        encodeURIComponent(key) + '=' + encodeURIComponent(object[key]);
      return temp;
    })
    .join(separator);
}
